export default [
  {
    path: "/administracao/assinaturas",
    component: () => import("@/layout/Default"),
    children: [
      {
        name: "assinaturas_configuracoes",
        path: "",
        component: () => import("./pages/Configuracoes"),
        meta: {
          breadcrumbs: [
            { label: "Assinaturas", to: "assinaturas_configuracoes" },
          ],
          permission: "assinaturas:view",
          title: "Administração - Configurações",
        },
      },
    ],
  },
];
